import { render } from "./bottom-block.vue?vue&type=template&id=2bf52596&scoped=true"
import script from "./bottom-block.vue?vue&type=script&lang=js"
export * from "./bottom-block.vue?vue&type=script&lang=js"

import "./bottom-block.vue?vue&type=style&index=0&id=2bf52596&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf52596"]])

export default __exports__